angular
	.module('widgetSitePicker')
	.controller('twMainCtrl', function ($scope, $location, dataFactory, tgConfig, $window) {
		$scope.siteForm = { siteOptions: [], site: {} }

		init()

		function init() {
			$scope.loader = true

			var urlParts = $location.path().split('/')
			if (!urlParts || urlParts.length == 0) return $location.path('/widgetSitePicker/notFound')

			$scope.siteForm.siteOptions = []
			$scope.siteForm.site = {}

			dataFactory
				.getVenuesByParent(urlParts[urlParts.length - 1])
				.then(function (venues) {
					if (venues && venues.data && venues.data.length > 0) {
						for (var i = 0; i < venues.data.length; i++) {
							var venue = venues.data[i]
							$scope.siteForm.siteOptions.push({ _id: venue._id, label: venue.name.pt })
						}
						$scope.siteForm.site = $scope.siteForm.siteOptions[0]
					} else {
						return $location.path('/widgetSitePicker/notFound')
					}
				})
				.catch(function (err) {
					var errMessage = err.data && err.data.error ? err.data.error : err
					console.log('Erro ao tentar buscar estabelecimentos:', errMessage)
				})
				.finally(function () {
					$scope.loader = false
				})
		}

		$scope.openSiteWidget = function () {
			if (!$scope.siteForm.site) return

			return ($window.location.href = tgConfig.widget + '/' + $scope.siteForm.site._id)
		}
	})
